import type { SVGProps } from 'react';
import * as React from 'react';

const RvtIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={40} height={44} viewBox="0 0 40 44" fill="none" aria-hidden="true" {...props}>
    <g id="file-icon/rvt">
      <g id="Vector" filter="url(#filter0_dd_3816_38113)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L35.3334 10.1111V38.3333C35.3334 39.8061 34.1505 41 32.6777 41C27.0142 41 13.7443 41 7.32677 41C5.85401 41 4.66675 39.82 4.66675 38.3473C4.66675 30.3468 4.66675 10.7752 4.66675 3.6498C4.66675 2.17704 5.86066 1 7.33341 1H26.2223Z"
          fill="url(#paint0_radial_3816_38113)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.2223 1L26.2224 7.44444C26.2224 8.9172 27.4163 10.1111 28.8891 10.1111L35.3334 10.1111L26.2223 1Z"
          fill="#F3F4F6"
        />
      </g>
      <g id="Vector_2">
        <path
          d="M23.9332 25.4819C23.9332 23.8499 26.0221 23.5235 26.0221 19.9333C26.0221 16.954 24.4737 15.1142 21.6485 14.2541C20.0165 13.7575 17.8718 13.6666 15.5777 13.6666C14.5332 13.6666 12.4443 13.6666 12.4443 13.6666V23.5235L15.0554 26.1999H19.2332L24.4554 31.9443L29.1554 34.5554C29.1554 34.5554 23.9332 27.0485 23.9332 25.4819ZM20.7999 19.9333C20.7999 21.0869 19.8646 22.0222 18.711 22.0222H18.1888C17.6117 22.0222 17.1443 21.5548 17.1443 20.9777V18.8888C17.1443 18.3118 17.6117 17.8444 18.1888 17.8444H19.2332C20.0985 17.8444 20.7999 18.5457 20.7999 19.4111V19.9333Z"
          fill="#1976D2"
        />
        <path
          d="M20.7954 19.9724C20.774 21.1077 19.8507 22.0221 18.7107 22.0221C18.7107 22.0221 18.5801 22.5444 17.601 23.4583C17.061 23.9622 15.5774 24.6333 15.5774 24.6333C15.5774 24.6333 21.3719 25.016 22.9913 21.7981C22.7203 20.866 21.95 20.1401 20.7954 19.9724Z"
          fill="#1565C0"
        />
        <path
          d="M19.755 16.2777H17.6661C16.8008 16.2777 16.0995 16.9791 16.0995 17.8444V19.4111C16.0995 20.7359 16.982 21.8185 17.9351 21.9877C17.4813 21.8738 17.1439 21.4665 17.1439 20.9777V18.8888C17.1439 18.3118 17.6113 17.8444 18.1884 17.8444H19.2328C20.0981 17.8444 20.7995 18.5457 20.7995 19.4111V19.9333C20.7995 19.9469 20.7959 19.9594 20.7954 19.9724C21.95 20.1401 22.7197 20.8654 22.9907 21.7976C23.2539 21.2759 23.4106 20.6623 23.4106 19.9333C23.4106 17.9144 21.7739 16.2777 19.755 16.2777Z"
          fill="#1950A6"
        />
        <path
          d="M17.6665 16.2777C16.8012 16.2777 16.0999 16.9791 16.0999 17.8444V19.4111C16.0999 20.7359 16.9824 21.8185 17.9355 21.9877C17.4817 21.8738 17.1443 21.4665 17.1443 20.9777V18.8888C17.1443 18.3118 17.6117 17.8444 18.1888 17.8444H19.2332C20.0985 17.8444 20.7999 18.5457 20.7999 19.4111V19.9333C20.7999 21.0869 19.8646 22.0222 18.711 22.0222C18.711 22.0222 21.8443 22.0222 21.8443 18.8888V18.3687C21.8443 17.2511 20.9664 16.3075 19.8494 16.2788C19.8181 16.2783 19.7868 16.2777 19.7554 16.2777H17.6665ZM12.4443 13.6666V33.511L14.5332 34.5554L15.5777 24.6333C15.5777 24.6333 12.4443 23.0666 12.4443 13.6666Z"
          fill="#0D47A1"
        />
        <path
          d="M14.5335 34.5555L15.578 24.6333C15.578 24.6333 18.7113 24.6333 20.278 25.6777C20.9589 26.1321 22.8515 28.3432 24.5863 30.3125C27.0015 33.0541 29.1557 34.5555 29.1557 34.5555C29.1557 34.5555 25.5654 34.2944 24.1356 34.0938C23.6786 34.0296 23.2567 33.8171 22.9893 33.4411C22.2065 32.3402 20.8002 29.5944 18.7113 27.5055C18.5886 27.3828 18.4502 27.247 18.1891 27.247C17.9233 27.247 17.6669 27.4543 17.6669 27.7719V33.1345C17.6669 33.3591 17.5232 33.5591 17.3097 33.6301L14.5335 34.5555Z"
          fill="#3AA2DB"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_dd_3816_38113"
        x={2.66675}
        y={0}
        width={34.6667}
        height={44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={0.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3816_38113" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="effect1_dropShadow_3816_38113" result="effect2_dropShadow_3816_38113" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_3816_38113" result="shape" />
      </filter>
      <radialGradient
        id="paint0_radial_3816_38113"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.0001 0.999999) rotate(90) scale(40 40.1825)"
      >
        <stop offset={0.297418} stopOpacity={0} />
        <stop offset={1} stopOpacity={0.03} />
      </radialGradient>
    </defs>
  </svg>
);
export default RvtIcon;
